import Highway from '@dogstudio/highway'
import store from '@js/modules/store'

export default class DefaultTransition extends Highway.Transition {
    in({ from, to, done }) {
        store.scrollino.listenScroll(0)

        if(window.innerWidth < 1280) {
            window.scrollTo({ top: 0 })
            document.body.classList.remove('-menu')
        }

        new Promise(resolve => {
            store.loader.progress(100, 0.5, resolve)
        }).then(() => {
            return new Promise(resolve => {
                store.loader.hide(resolve)
            })
        }).then(() => {
            document.body.classList.remove('-loading')
            done()
        })
    }

    out({ from, trigger, done }) {
        if(trigger == 'popstate' || document.body.classList.contains('-loggedIn')) {
            location.reload()
            return false
        }

        new Promise(resolve => {
            store.loader.show(resolve)
        }).then(() => {
            document.body.classList.add('-loading')
            return new Promise(resolve => {
                store.loader.progress(42, 0.5, resolve)
            })
        }).then(() => {
            from.remove()
            done()
        })
    }
}